import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main.jsx';
import './core.scss'

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>, 
  document.getElementById('root'),
);
